import { gqlClient } from 'services/api/gql/gqlClient';
import { ProductComparison } from 'constants/gql/queries/productComparison/productComparison.gql';
import localeUtils from 'utils/LanguageLocale';

const getProductComparison = async (requestParams = {}) => {
    Sephora.logger.verbose('getProductComparison called with params:', requestParams);

    const locale = `${localeUtils.getCurrentLanguage().toUpperCase()}_${localeUtils.getCurrentCountry()}`;

    try {
        const options = {
            query: ProductComparison,
            operationName: 'ProductComparison',
            variables: {
                skuIds: requestParams.skuIds || [],
                locale: locale,
                quantity: 3
            },
            allowPartialResponse: true
        };

        const result = await gqlClient.query(options);

        return result;
    } catch (error) {
        Sephora.logger.error('Error in getProductComparison:', error);
        throw error;
    }
};

export default getProductComparison;
